import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import InformationOutlineIcon from 'mdi-react/InformationOutlineIcon';
import CheckBox from '../../../../shared/components/CheckBox';
import { updateCalculationFilter } from '../../../../redux/reducers/brand/ConfirmedDealsReducer';

// Each toggle: what happens when it is OFF (default) vs ON.
const TOGGLES = [
  {
    name: 'includeHistoricalConversions',
    label: 'Include Historical Conversions',
    off: "Counting starts on the video's publish date.",
    on: 'Also counts conversions from earlier in the period — before this video was published, but not earlier than the previous video.',
  },
  {
    name: 'includeFutureConversions',
    label: 'Include Future Conversions',
    off: "Counting stops on the period's end date.",
    on: 'Also counts conversions after the period ends — until today or the next video, whichever comes first.',
  },
  {
    name: 'includePreviouslyPublishedConversions',
    label: 'Include Conversions from Previously Published Content',
    off: 'Shows only conversions from creators who published during the timeframe.',
    on: 'Adds all other conversions in the period from creators who had no published content in the period — giving the true TOTAL number of conversions for the brand in the period.',
  },
];

const tooltipContent = ({ off, on }) => (
  <div style={{ fontSize: '12px', lineHeight: 1.4 }}>
    <div style={{ marginBottom: '6px' }}>
      <strong>Off:</strong> {off}
    </div>
    <div>
      <strong>On:</strong> {on}
    </div>
  </div>
);

const ConversionToggles = ({ filters, dispatch }) => (
  <div className="d-flex align-items-center flex-wrap">
    {TOGGLES.map(toggle => (
      <div key={toggle.name} className="mr-4 d-flex align-items-center">
        <CheckBox
          name={toggle.name}
          label={toggle.label}
          value={filters[toggle.name]}
          onChange={(e) => {
            if (e && e.target) {
              dispatch(updateCalculationFilter(toggle.name, !filters[toggle.name]));
            }
          }}
          className="inline"
          defaultChecked={false}
        />
        <Tooltip title={tooltipContent(toggle)} arrow>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              color: '#70bbfd',
              marginLeft: 4,
              marginBottom: 8,
            }}
          >
            <InformationOutlineIcon size={15} />
          </span>
        </Tooltip>
      </div>
    ))}
  </div>
);

ConversionToggles.propTypes = {
  filters: PropTypes.shape({
    includeHistoricalConversions: PropTypes.bool,
    includeFutureConversions: PropTypes.bool,
    includePreviouslyPublishedConversions: PropTypes.bool,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default ConversionToggles;
